import { Component, Prop, Vue } from "vue-property-decorator";
import classNames from "classnames";
import { fmtMsg } from "commonui";

@Component({
	components: {}
})
export default class LabelText extends Vue {
	@Prop() label!: string;
	@Prop() labelId!: string;
	@Prop() hasColon!: boolean;
	@Prop() text?: string;
	@Prop() customTextClass?: string;

	formatMessage(id: string, params?: any): string {
		return fmtMsg(id, params);
	}

	mergedClass(className: string): string {
		return classNames(className);
	}

	get labelClassName(): any {
		return {
			"label-text-label": true,
			"label-text-lable-with-colon": this.hasColon,
			"label-text-label-with-text": this.text != null
		};
	}

	get textClassName(): string {
		return `label-text-text ${this.customTextClass}`;
	}
}
